import { DateField } from 'react-admin';
import { timeZone } from '../utils/constants';
import { useMemo } from 'react';

export default function DateFieldWithTimeZone({
  options,
  transform,
  emptyText = '-',
  ...rest
}) {
  const mergedOptions = useMemo(
    () => ({
      timeZone,
      hour12: false, // 24 hour format
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      ...options,
    }),
    [options],
  );

  const transformValue = value =>
    transform ? transform(normalizeDate(value)) : normalizeDate(value);

  return (
    <DateField
      options={mergedOptions}
      transform={transformValue}
      emptyText={emptyText}
      {...rest}
    />
  );
}

function normalizeDate(value) {
  if (value === undefined || value === null || value === '') {
    return value;
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return new Date(value);
  }
  if (typeof value === 'object') {
    if (typeof value.toDate === 'function') {
      const result = value.toDate();
      return result instanceof Date ? result : normalizeDate(result);
    }
    if (typeof value.seconds === 'number') {
      const nanos =
        typeof value.nanoseconds === 'number'
          ? value.nanoseconds
          : typeof value.nanos === 'number'
          ? value.nanos
          : 0;
      const millis = value.seconds * 1000 + Math.floor(nanos / 1e6);
      return new Date(millis);
    }
    if (typeof value._seconds === 'number') {
      const nanos =
        typeof value._nanoseconds === 'number'
          ? value._nanoseconds
          : typeof value.nanoseconds === 'number'
          ? value.nanoseconds
          : 0;
      const millis = value._seconds * 1000 + Math.floor(nanos / 1e6);
      return new Date(millis);
    }
  }
  return new Date(value);
}
